import { images } from 'styles';
import { L } from 'libs/i18n';

const onboardingTexts = {
    title: {
        signup: L('journey_start'),
        login: L('journey_continue'),
        resetPassword: L('reset_your_password')
    },
    loginText: {
        login: L('log_in'),
        signup: L('sign_up')
    }
};

const sessionTypes = [
    {
        id: 'guided',
        name: 'Guided',
        tags: [
            {
                id: 'toneofvoice',
                name: 'Tone of voice'
            },
            {
                id: 'makeitshorter',
                name: 'Make it shorter'
            },
            {
                id: 'makeitlonger',
                name: 'Make it longer'
            },
            {
                id: 'moreguidance',
                name: 'More guidance'
            },
            {
                id: 'notinthemood',
                name: 'Not in the mood'
            }
        ]
    },

    {
        id: 'foodforthought',
        name: 'Food for thought',
        tags: [
            {
                id: 'toneofvoice',
                name: 'Tone of voice'
            },
            {
                id: 'makeitshorter',
                name: 'Make it shorter'
            },
            {
                id: 'makeitlonger',
                name: 'Make it longer'
            },
            {
                id: 'moreguidance',
                name: 'More guidance'
            },
            {
                id: 'notinthemood',
                name: 'Not in the mood'
            }
        ]
    },
    {
        id: 'theory',
        name: 'Theory',
        tags: [
            {
                id: 'toneofvoice',
                name: 'Tone of voice'
            },
            {
                id: 'lessfacts',
                name: 'Less facts'
            },
            {
                id: 'moreexplanation',
                name: 'More explanation'
            },
            {
                id: 'moreinteresting',
                name: 'More interesting'
            },
            {
                id: 'readsummaryinstead',
                name: 'Read summary instead'
            }
        ]
    },
    {
        id: 'stories',
        name: 'Stories',
        tags: [
            // {
            //     id: 'toneofvoice',
            //     name: 'Tone of voice'
            // },
            // {
            //     id: 'changestoryline',
            //     name: 'Change storyline'
            // },
            // {
            //     id: 'addsoundeffects',
            //     name: 'Add sound effects'
            // },
            // {
            //     id: 'morearousal',
            //     name: 'More arousal'
            // }
        ]
    }
];

const defaultRemindersGroups = {
    global: {
        type: 'global',
        title: 'Me-time Reminder',
        subtitle: 'Commit to your goals',
        icon: images.reminderGlobal,
        reminderId: 1000
    },
    bodyPositive: {
        type: 'habit',
        title: 'Body Positive Reminder',
        subtitle: 'Love yourself more',
        icon: images.reminderBody,
        reminderId: 1001
    },
    arouseMind: {
        type: 'habit',
        title: 'Turn-ons Reminder',
        subtitle: 'Get in the mood',
        icon: images.reminderArouse,
        reminderId: 1002
    },
    selfTalk: {
        type: 'habit',
        title: 'Self-Talk Reminder',
        subtitle: 'Get rid of your inner critic',
        icon: images.reminderSelfTalk,
        reminderId: 1003
    },
    dailyPleasures: {
        type: 'habit',
        title: 'Daily Pleasures Reminder',
        subtitle: 'Re-discover your everyday life',
        icon: images.reminderDailyPleasure,
        reminderId: 1004
    }
};

const defaultRemindersWeekDays = [
    {
        id: 'mon',
        letter: 'M',
        active: true,
        order: 1,
        reminderId: 101
    },
    {
        id: 'tue',
        letter: 'T',
        active: true,
        order: 2,
        reminderId: 102
    },
    {
        id: 'wed',
        letter: 'W',
        active: true,
        order: 3,
        reminderId: 103
    },
    {
        id: 'thu',
        letter: 'T',
        active: true,
        order: 4,
        reminderId: 104
    },
    {
        id: 'fri',
        letter: 'F',
        active: true,
        order: 5,
        reminderId: 105
    },
    {
        id: 'sat',
        letter: 'S',
        active: true,
        order: 6,
        reminderId: 106
    },
    {
        id: 'sun',
        letter: 'S',
        active: true,
        order: 0,
        reminderId: 100
    }
];

const feedbackTextsVariations = {
    askReview: { title: ['Amazing!', 'Awesome!', 'Good for you!'], subtitle: 'Please rate this session' },
    continueListening: {
        title: 'Thank you for your review!',
        subtitle: ['Keep going!', "You're doing great!", 'Good one!']
    }
};

const sitTOS =
    '<h4><strong>Privacy Policy applicable to Emjoy Personalization Test</strong></h4><p><b>Do I need to pass this test to be able to continue consuming Emjoy’s content?</b></p><p>Absolutely not. This test is voluntary and not necessary to have access to our content. You can exit it at any time.</p><br><p><strong>What does Emjoy do with my answers to the personalization test?</strong></p><p>Based on your responses, we will suggest which goals you should activate to enjoy a more personalized experience in the app and it will also help us to create new content of your interest.</p><br><p><strong>What is the legal basis of the data processing?</strong></p><p>Emjoy will be able to use your responses to the test to improve your experience in the app, because you have given your explicit consent before starting the test.&nbsp;</p><br><p><strong>Who will have access to my answers?</strong></p><p>Emjoy will be the only one having access to your personal data. We won’t disclose your answers to third parties without your prior express consent.</p><br><p><strong>How long will this data be stored?</strong></p><p>The test results will be stored for a maximum period of one year. After that, they will be destroyed or duly anonymized and only used for statistical purposes.</p><br><p><strong>Does Emjoy make automated decisions, including profiling, based on my results?</strong></p><p>No. All decisions that Emjoy will make based on the results of your test will be, in whole or in part, taken by individuals.</p><br><p><strong>What rights can I exercise regarding my personal data and where can I contact the personal data controller?</strong></p><p>You can exercise all your GDPR rights (information, access, rectification, erasure, objection, restriction, portability) and withdraw your consent at any time reaching us at support@letsemjoy.com.</p><p>You further have the right to lodge a complaint with a supervisory authority.</p><p>Please refer to our <a href="https://privacy-policy">Privacy Policy</a> to know more about the way Emjoy treats your personal information in general.</p>';

const desireTOS =
    '<h4><strong>Privacy Policy applicable to Emjoy Tests</strong></h4><p><strong>Do I need to pass this test to be able to continue consuming Emjoy&rsquo;s content?</strong></p><p>Absolutely not. This test is voluntary and not necessary to have access to our content. You can exit it at any time.&nbsp;</p><br><p><strong>What does Emjoy do with my answers to the test?</strong></p><p>Based on your responses, Emjoy tells you what kind of sexual type you may identify most with and recommends to you personalized content and healthy habits and practices.</p><br><p><strong>What is the legal basis of the data processing?</strong></p><p>Emjoy will be able to use your responses to the test to improve your experience in the app, because you have given your explicit consent before starting the test.</p><br><p><strong>Who will have access to my answers?</strong></p><p>Emjoy will be the only one having access to your personal data. We won&rsquo;t disclose your answers to third parties without your prior expressed consent.</p><br><p><strong>How long will this data be stored?</strong></p><p>The test results will be stored for a maximum period of one year. After that, they will be destroyed or duly anonymized and only used for statistical purposes.</p><br><p><strong>Does Emjoy make automated decisions, including profiling, based on my results?</strong></p><p>No. All decisions that Emjoy will make based on the results of your test will be, in whole or in part, taken by individuals.</p><br><p><strong>What rights can I exercise regarding my personal data and where can I contact the personal data controller?</strong></p><p>You can exercise all your GDPR rights (information, access, rectification, erasure, objection, restriction, portability) and withdraw your consent at any time reaching us at support@letsemjoy.com</p><p>You further have the right to lodge a complaint with a supervisory authority.</p><p>Please refer to our <a href="https://privacy-policy">Privacy Policy</a> to know more about the way Emjoy treats your personal information in general.</p>';

const subscriptionsManagement = {
    subscriptionsId: {
        monthly1099: 'com.letsemjoy.monthly1099',
        yearly1999: 'com.letsemjoy.yearly1999',
        yearly2999: 'com.letsemjoy.yearly2999',
        yearly2999ft14: 'com.letsemjoy.yearly2999ft14',
        welcome4999: 'com.letsemjoy.welcome4999',
        quarterly1699: 'com.letsemjoy.quarterly1699',
        yearly2999intro1999: 'com.letsemjoy.yearly2999intro1999'
    },
    period: {
        quarterly: 'quarterly',
        monthly: 'monthly',
        yearly: 'yearly'
    }
};

const ids = {
    partnerSelectorIds: {
        yes: 'yes',
        no: 'no'
    },
    confidenceSelectorIds: {
        not: 'not',
        okay: 'okay',
        very: 'very'
    },
    settingsIds: {
        support: 'support'
    }
};

const emails = {
    support: 'support@letsemjoy.com'
};

const urls = {
    storeLinkIos: 'itms-apps://apps.apple.com/account/subscriptions',
    storeLinkAndroid: 'https://play.google.com/store/account/subscriptions'
};

const authErrorsManagement = {
    weakPassword: 'auth/weak-password',
    invalidEmail: 'auth/invalid-email',
    emailInUse: 'auth/email-already-in-use',
    accountExists: 'auth/account-exists-with-different-credential',
    userNotFound: 'auth/user-not-found',
    wrongPassword: 'auth/wrong-password',
    notValidSignInMail: 'auth/invalid-action-code',
    alreadyInUse: 'auth/credential-already-in-use'
};

const storiesLayoutHeight = 192; // Stories card height plus margins

//TODO to lang.json
const paywallPageNewfeaturesList = [
    'Sexy audio stories for all moods',
    '+ 300 wellness sessions on increasing libido, orgasms, discovering your body and more',
    'Daily Routines to increase your self-love',
    'New releases added every week'
];

export {
    authErrorsManagement,
    defaultRemindersGroups,
    defaultRemindersWeekDays,
    desireTOS,
    emails,
    feedbackTextsVariations,
    ids,
    onboardingTexts,
    sessionTypes,
    sitTOS,
    storiesLayoutHeight,
    subscriptionsManagement,
    urls,
    paywallPageNewfeaturesList
};
